/**
 * Tag-membership predicates for the case-list "untagged" filter.
 *
 * Only STAGE tags exist now — the user-tag category was retired; case
 * ownership is the `Case.assignedTo` relation (check `c.assignedTo` directly).
 * This stays a pure check over the case's `tags` relation, so the store
 * (`displayedActiveCases`) and the toolbar counts share one source of truth.
 */

/**
 * @param {{ tags?: Array<{ tag?: { category?: string } }> }} c
 * @returns {boolean} true when the case has NO stage-category tag.
 */
export function isCaseWithoutStageTags(c) {
  return !(c?.tags ?? []).some(t => t.tag?.category === 'stage')
}
